
import React, { useEffect, useState } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Dialog,
  DialogTitle,
  DialogContent
} from '@mui/material';
import { useAppContext } from '../context/AppContext';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { financialService } from '../utils/api';

function Experience() {
  const { state, actions } = useAppContext();
  const [timeoutDialogOpen, setTimeoutDialogOpen] = useState(false);
  
  const [value,setValues] = useState({
    objective: state.objective || '',
    concerns: state.concerns || '',
    yearsInEquity: state.yearsInEquity || '',
  });

  useEffect(() => {
    setValues(
      {
        objective: state.objective || '',
        concerns: state.concerns || '',
        yearsInEquity: state.yearsInEquity || '',
      }
    )
  }, [state.objective, state.concerns, state.yearsInEquity])
  
  const handleChange = (field) => (e) => {
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

const handleSubmit = async () => {
  const errors = [];

  try {
    await financialService.submitCashFlow(state.phoneNumber, {
      salary: state.salary,
      spouse_salary: state.spouseSalary,
      other_income: state.otherIncome,
      monthly_expense: state.monthlyExpense,
      one_time_yearly: state.oneTimeYearly,
      annual_investments: state.annualInvestments,
      sip: state.sip
    });
  } catch (err) {
    console.error("CashFlow Error:", err);
    errors.push("Cash Flow failed");
  }

  try {
    await financialService.submitInvestment(state.phoneNumber, {
      bank_balance: state.bankBalance,
      fixed_deposit: state.fixedDeposit,
      retirement_fund: state.retirementFund,
      bonds: state.bonds,
      debt_mf: state.debtMF,
      equity_mf: state.equityMF,
      hybrid_mf: state.hybridMF,
      invits: state.invits,
      stocks: state.stocks,
      pms: state.pms,
      unlisted: state.unlisted,
      global_equity: state.globalEquity,
      global_bonds: state.globalBonds,
      global_mf: state.globalMF,
      real_estate: state.realEstate,
      gold: state.gold,
      other_investments: state.otherInvestments
    });
  } catch (err) {
    console.error("Investment Error:", err);
    errors.push("Investment failed");
  }

  try {
    await financialService.updateUserInfo(state.phoneNumber, {
      occupation: state.occupation,
      employer: state.employer,
      dependents: state.dependents,
      objective: state.objective,
      concerns: state.concerns,
      years_in_equity: state.yearsInEquity
    });
  } catch (err) {
    console.error("User Info Error:", err);
    errors.push("User info update failed");
  }

  try {
    await financialService.emailRecord(state.phoneNumber);
  } catch (err) {
    console.error("Email Error:", err);
    errors.push("Email failed");
  }

  if (errors.length > 0) {
    console.log("Some APIs failed:", errors);
  } else {
    console.log("All APIs successful");
  }
};

  return (
    <Box>
      <CardContent>
      <Box sx={{ mb: 2}}>
      <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>
            Investment Experience
          </Typography>
          <Typography variant="body1" component="h2" gutterBottom>
           What is your primary investment objective? 
          </Typography>
      
          <TextField
            value={value.objective || ''}
            onChange={(e) => actions.updateFormData('objective', e.target.value)}
            fullWidth
            placeholder="Fulfilling goals, wealth maximisation, etc."
          />
        </Box>

        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
           What concerns do you have about your finances or investments?
          </Typography>
      
          <TextField
            value={value.concerns || ''}
            onChange={(e) => actions.updateFormData('concerns', e.target.value)}
            fullWidth
            placeholder="Returns, Diversification, etc."
          />
        </Box>
        
        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
         How many years have you been investing in Equity Market?
        </Typography>
        
          {/* <TextField
            value={formatNumber(value.yearsInEquity) || ''}
            onChange={(e) => actions.updateFormData('yearsInEquity', e.target.value)}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='Experience in Equity Markets'
          /> */}
          <FormControl fullWidth>
          <Select
            fullWidth
            value={value.yearsInEquity || ''}
            onChange={(e) => actions.updateFormData('yearsInEquity', e.target.value)}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
          >
            <MenuItem value="">
              <em>Select Options</em>
            </MenuItem>
            <MenuItem value="<3">{"< 3 years"}</MenuItem>
            <MenuItem value="3-5">3 - 5 years</MenuItem>
            <MenuItem value="5-10">5 - 10 years</MenuItem>
            <MenuItem value=">10">{"> 10 years"}</MenuItem>
          </Select>
        </FormControl>


        </Box>
        <Button
          variant="contained"
          color="success"
          endIcon={<ArrowForwardIcon />}
          onClick={() => {
            handleSubmit()
            actions.nextStepAsset()
          }}
          sx={{ 
            borderRadius: 1, 
            textTransform: 'none', 
            fontWeight: 'bold', 
            width: 250,        // fixed width so it doesn’t break
            height: 56, 
            mt: 4, 
            mx: "auto", 
            display: "flex", 
            justifyContent: "center",  // keep text + arrow in one row
            alignItems: "center"       // vertical alignment
          }}
        >
          Explore Insights
        </Button>
      </CardContent>
      <Dialog open={timeoutDialogOpen} onClose={() => {}} fullWidth maxWidth="xs">
        <DialogTitle>Session Timeout</DialogTitle>
        <DialogContent>
          <Typography>
            You took too much time to submit the request. Reloading the page...
          </Typography>
        </DialogContent>
      </Dialog>
</Box>
  );

}

export default Experience;
